import {
  ChangeDetectorRef,
  Component,
  inject,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Summary } from "../../../shared/components/dashboard/summary-cards/summary-cards.component";
import {
  faBell,
  faBuilding,
  faCircleExclamation,
  faDroplet,
  faExclamation,
  faHome,
  faLocation,
  faLocationCrosshairs,
  faTemperatureEmpty,
  faThermometer,
  faWarehouse,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { SettingsService } from "../../../services/settings.service";
import { WarehousesModalComponent } from "./warehouses-modal/warehouses-modal.component";
import { AlertModalComponent } from "./alert-modal/alert-modal.component";
import { TempStabilityModalComponent } from "./temp-stability-modal/temp-stability-modal.component";
import { HumidityStabilityModalComponent } from "./humidity-stability-modal/humidity-stability-modal.component";
import { faDotCircle } from "@fortawesome/free-solid-svg-icons/faDotCircle";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { Router } from "@angular/router";
import { TableConfiguration } from "../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { SensorModalComponent } from "./sensor-modal/sensor-modal.component";
import { GET_MAIN_DASHBOARD_DATA } from "../../../store/entities/warehouse-management/alert-dashboard/alert-dashboard.graphql";
import { GraphqlService } from "../../../services/graphql.service";
import { animate, style, transition, trigger } from "@angular/animations";
import {
  ApexAxisChartSeries,
  ApexOptions,
  ChartComponent,
  ChartType,
} from "ng-apexcharts";
import { Store } from "@ngrx/store";
import { AppState } from "../../../store";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { selectStoreItems } from "../../../store/entities/store-item/store-item.selectors";
import {
  WarehouseDashboardData,
  ZoneDashboardData,
  ZoneDashboardStoreResponse,
} from "../../../store/entities/warehouse-management/general-dashboard/general-dashboard.model";
import {
  GET_WAREHOUSE_DASHBOARD_AVARAGE_READING_QUERY,
  GET_ZONE_DASHBOARD_AVARAGE_READING_QUERY,
} from "../../../store/entities/warehouse-management/general-dashboard/general-dashboard.graphql";
import {
  Alert,
  AlertService,
} from "./alert-modal/alertService/alert-shared-service";
import { gql } from "graphql-tag";
import { AlertsModalComponent } from "../warehouses-list/warehouse-view/alerts-modal/alerts-modal.component";
import { TotalInstalledSensorModalComponent } from "./total-installed-sensor-modal/total-installed-sensor-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { take } from "rxjs";
const GET_WAREHOUSE_ALERT_COUNT = gql`
  query GetAlertsByWarehouseCount {
    getAlertsByWarehouseCount {
      data {
        totalAlerts
        alertsByWarehouse {
          warehouseName
          warehouseUniqueId
          alertsCount
        }
      }
      response {
        id
        status
        code
        message
      }
    }
  }
`;

const GET_WAREHOUSE_READING_STABILITY = gql`
  query GetWarehouseReadingStability {
    getWarehouseReadingStability {
      response {
        id
        status
        code
        message
      }
      data {
        dashboardData
      }
    }
  }
`;
const GET_UNSTABLE_WAREHOUSE_READING = gql`
  query GetUnstableWarehouseReading {
    getUnstableWarehouseReading {
      response {
        status
      }
      data {
        dashboardData
      }
    }
  }
`;

interface Stability {
  warehouse_name: string;
  temp_stability: number;
  humidity_stability: number;
}

@Component({
  selector: "app-warehouse-management-dashboard",
  templateUrl: "./warehouse-management-dashboard.component.html",
  styleUrl: "./warehouse-management-dashboard.component.scss",
  animations: [
    trigger("fadeIn", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateY(10px)" }),
        animate(
          "0.8s ease-in-out",
          style({ opacity: 1, transform: "translateY(0)" }),
        ),
      ]),
    ]),
  ],
})
export class WarehouseManagementDashboardComponent implements OnInit {
  @ViewChild("chart") chart!: ChartComponent;
  @ViewChild("radialChart") radialChartRef!: ChartComponent;

  private dialog = inject(MatDialog);
  private settingsService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);
  private apollo: GraphqlService = inject(GraphqlService);
  private store: Store<AppState> = inject(Store);
  private ngZone: NgZone = inject(NgZone);
  private alertService: AlertService = inject(AlertService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  loadingData: boolean = false;
  warehouseDashboardData: WarehouseDashboardData[] = [];
  currentView: "warehouse" | "zone" = "warehouse";
  selectedWarehouseId: string | null = null;
  originalWarehouseChart: any = null;
  warehouseAlertCount: any = null;
  title: string = "Warehouse Dashboard";
  summaryCard: Summary[] = [];
  unstableLabels: string[] = [];
unstableSeries: ApexAxisChartSeries = [
  { name: "Overall Stability (%)", data: [] },
  { name: "Overall Instability (%)", data: [] },
];
  // stabilityReadings: Stability[] = [];
  showChart: boolean = false;
  stabilityResponse: any = null;
  stabilityReadings: any[] = [];
  unstableColors: string[] = [];

  // Example color palette
  cardColors = [
    "bg-red-100",
    "bg-green-100",
    "bg-blue-100",
    "bg-yellow-100",
    "bg-purple-100",
    "bg-pink-100",
    "bg-indigo-100",
    "bg-teal-100",
  ];

  tempLabels: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  tempSeries: ApexAxisChartSeries = [
    { name: "Avg Temp", data: [22, 24, 23, 26, 25] },
  ];

  humLabels: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  humSeries: ApexAxisChartSeries = [
    { name: "Avg Humidity", data: [65, 68, 70, 66, 72] },
  ];

  alertLabels: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  alertSeries: ApexAxisChartSeries = [
    { name: "Alerts", data: [3, 5, 2, 8, 4] },
  ];

  barChart: ApexOptions = {
    chart: {
      type: "area",
      height: 320,
      toolbar: { show: false },

      animations: { enabled: true },
    },
    stroke: {
      show: true,
      curve: "smooth",
      width: [1, 1],
    },
    dataLabels: { enabled: false },
    plotOptions: {
      area: {
        fillTo: "origin",
      },
    },
    series: [
      { name: "Temperature", data: [] },
      { name: "Humidity", data: [] },
    ],

  xaxis: {
    categories: [],
    labels: {
      style: { fontSize: "12px", fontWeight: "normal" },
      rotate: -45,
      trim: false,
      maxWidth: 600,
    } as any,
    tickPlacement: "between",
    offsetX: 0,


    title: {
      text: "Warehouses Name",
      style: {
        fontSize: "12px",
        fontWeight: 600,
      },
    },
  },
   yaxis: {
    title: {
      text: "Average Value (°C / %)",
      style: {
        fontSize: "12px",
        fontWeight: 600,
      },
    },
  },

    colors: ["#7f8bfa", "#5ed2d3"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
  };

  radialChart = {
    chart: {
      type: "radialBar" as ChartType,
      height: 320,
    },
    series: [25, 30, 15, 20, 10, 5, 15],
    labels: [
      "Dar es Salaam",
      "Tanga",
      "Tabora",
      "Mbeya",
      "Mtware",
      "Dodoma",
      "Dodoma HQ",
    ],
    plotOptions: {
      radialBar: {
        hollow: { size: "10%" },
        track: {
          background: "#79a6ff1A",
          strokeWidth: "100%",
          margin: 4,
        },
        dataLabels: {
          name: {
            show: true,
            showOn: "always",
            fontSize: "14px",
            color: "#4a403a",

            align: "left",
            formatter: (val) => val,
          },
          value: { show: true },
          total: { show: true, formatter: () => "100" },
        },
      },
    },
    legend: {
      show: true,
      position: "left",
      horizontalAlign: "left",
      fontSize: "14px",
      offsetX: -20,
      labels: { colors: "#4a403a" },
      formatter: (seriesName: string, opts: any) => seriesName,
    },
    stroke: {
      curve: "smooth",
      width: 10,
    },
    colors: [
   "#3B5BDB", 
  "#0CA678", 
  "#F08C00", 
  "#C2255C", 
  "#495057", 
  "#6741D9", 
  "#1C7ED6", 
  "#2B8A3E", 
  "#A61E4D", 
  "#087F5B", 
    ],
  };

  tableConfigurationReadings: TableConfiguration = {
    tableColumns: [
      { name: "name", label: "Name" },
      { name: "currentReadings", label: "Average Current Readings" },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: false,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  tableConfigurationStability: TableConfiguration = {
    tableColumns: [
      { name: "name", label: "Name" },
      { name: "tempStability", label: "Temperature Stability" },
      { name: "HumidityStability", label: "Humidity Stability" },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: false,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };
  dashboardData: any;

  ngOnInit(): void {
    this.fetchMainDashboardData();
    this.fetchWarehouseDetails();
    this.loadAlertData();
    this.getAlertCount();
    this.fetchStability();
    this.fetchUnstableWarehouseReading()
    this.originalWarehouseChart = { ...this.barChart };
    this.title = "";
    // AOS.init({ once: true });
    setTimeout(() => {
      this.showChart = true;
    }, 1000);
  }

  getAlertCount = () => {
    this.store.dispatch(
      StoreItemActions.getStoreItems({
        entity: StoreItemEntity.warehouseAlertCount,
        query: GET_WAREHOUSE_ALERT_COUNT,
        filtering: {},
      }),
    );
    this.store
      .select(selectStoreItems(StoreItemEntity.warehouseAlertCount))
      .subscribe((res) => {
        this.warehouseAlertCount = res[0];
      });
  };

  customAction(event: any) {
    if (event?.action == "more") return {};
  }

  cardClicked(
    type:
      | "total"
      | "alert-today"
      | "alert"
      | "temperature"
      | "humidity"
      | "sensor",
  ) {
    switch (type) {
      case "total":
        this.router.navigateByUrl(
          "/manage/warehouse-management/warehouse-list",
        );
        break;
      case "alert-today":
        this.settingsService.openDialogModal({
          component: AlertsModalComponent,
          data: { duration: "TODAY" },
        });
        break;
      case "alert":
        this.store
          .select(selectStoreItems(StoreItemEntity.warehouseAlertCount))
          .pipe(take(1))
          .subscribe((res) => {
            const warehouseData = res[0];
            const topWarehouse = warehouseData?.alertsByWarehouse?.[0];
            const warehouseIdToPass = topWarehouse?.warehouseUniqueId ?? null;

            this.settingsService.openDialogModal({
              component: AlertsModalComponent,
              data: {
                alertCount: warehouseData,
                warehouseUniqueId: warehouseIdToPass,
              },
            });
          });
        break;

      case "temperature":
        this.settingsService.openDialogModal({
          component: TempStabilityModalComponent,
          data: { stability: this.stabilityResponse },
        });
        break;

      case "humidity":
        this.settingsService.openDialogModal({
          component: HumidityStabilityModalComponent,
          data: { stability: this.stabilityResponse },
        });
        break;

      case "sensor":
        this.settingsService.openDialogModal({
          component: TotalInstalledSensorModalComponent,
          data: {},
        });
    }
  }
async fetchUnstableWarehouseReading() {
  try {
    const result: any = await this.apollo.query({
      query: GET_UNSTABLE_WAREHOUSE_READING,
      variables: {},
    });

    const responseBlock = result?.data?.getUnstableWarehouseReading;

    if (responseBlock?.response?.status) {
      const rawDashboardData = responseBlock?.data?.dashboardData;

      const parsed =
        typeof rawDashboardData === "string"
          ? JSON.parse(rawDashboardData)
          : rawDashboardData;

      const sorted = parsed
        .sort(
          (a: any, b: any) => b.overall_instability - a.overall_instability
        )
        .slice(0, 5);

      this.unstableLabels = sorted.map(
        (item: any) => item.warehouse__name
      );

      const instabilityData = sorted.map(
        (item: any) => Number(item.overall_instability.toFixed(1))
      );

    
      const max = Math.max(...instabilityData);
      const min = Math.min(...instabilityData);

      const colors = instabilityData.map((val) => {
      
        const intensity = 0.3 + 0.7 * ((val - min) / (max - min || 1));
        return `rgba(220, 38, 38, ${intensity})`; 
      });

      this.unstableSeries = [
        {
          name: "Instability (%)",
          data: instabilityData,
        },
      ];

      this.unstableColors = colors; 
    }
  } catch (error) {
    console.error("Error fetching unstable data:", error);
  }
}

  async fetchMainDashboardData(): Promise<void> {
    this.loadingData = true;
    this.showChart = false;
    try {
      const response: any = await this.apollo.query({
        query: GET_MAIN_DASHBOARD_DATA,
        variables: {
          filtering: { timerange: "TODAY" },
        },
      });

      const dashboardDataString =
        response?.data?.getMainDashboardData?.data?.dashboardData;
      if (dashboardDataString) {
        try {
          const parsedData = JSON.parse(dashboardDataString);
          this.dashboardData = parsedData;
          this.summaryCard = [
            {
              title: "Warehouses",
              component: WarehousesModalComponent,
              data: [
                {
                  title: "warehouses",
                  icon: faHome,
                  value: parsedData.WAREHOUSES ?? "15",
                  color: "text-green-500",
                  chips: [
                    {
                      background: "white",
                      title: "Zones",
                      value: parsedData.ZONES ?? "10",
                      icon: faLocation,
                      iconColor: "text-green-500",
                    },
                    {
                      background: "white",
                      title: "Sensors",
                      value: parsedData.SENSORS ?? "120",
                      icon: faBuilding,
                    },
                  ],
                },
              ],
            },
            {
              title: "Alerts",
              component: AlertModalComponent,
              data: [
                {
                  title: "Alerts",
                  icon: faBell,
                  value: parsedData.ALERTS?.TOTAL_ALERTS ?? "25",
                  color: "text-yellow-500",
                  chips: [
                    {
                      background: "white",
                      title: "Resolved Alerts",
                      value: parsedData.ALERTS?.RESOLVED_ALERTS ?? "40",
                      icon: faWarning,
                      iconColor: "text-yellow-500",
                    },
                    {
                      title: "Unresolved Alerts",
                      value: parsedData.ALERTS?.UNRESOLVED_ALERTS ?? "20",
                      icon: faExclamation,
                      iconColor: "text-red-500",
                    },
                  ],
                },
              ],
            },
          ];
        } catch (error) {
          console.error("Error parsing dashboardData:", error);
        }
      } else {
        console.error("dashboardData is not available");
      }
    } catch (error) {
     
    } finally {
      this.loadingData = false;
      this.showChart = true;
    }
  }

  async fetchWarehouseDetails() {
    const result = await this.apollo.query({
      query: GET_WAREHOUSE_DASHBOARD_AVARAGE_READING_QUERY,
      variables: [],
    });
    const { data, response } = result.data.getWarehouseDashboardAverageReading;
    if (response.status) {
      this.processWarehouseDashboardData(data);
    }
  }

  async fetchStability() {
   

    try {
      const result: any = await this.apollo.query({
        query: GET_WAREHOUSE_READING_STABILITY,
        variables: {},
      });

      const responseBlock = result?.data?.getWarehouseReadingStability;

      if (responseBlock?.response?.status) {
        const rawDashboardData = responseBlock?.data?.dashboardData;

        const parsed =
          typeof rawDashboardData === "string"
            ? JSON.parse(rawDashboardData)
            : rawDashboardData;

        this.stabilityResponse = parsed;
        this.stabilityReadings = parsed?.warehouses ?? [];

       
      }
    } catch (error) {
      console.error("Error fetching stability:", error);
    }
  }

  processWarehouseDashboardData(data: any) {
    if (data) {
      try {
        let modifiedData = data.dashboardData.replace(
          /("warehouse_id":\s*)(\d+)/g,
          '$1"$2"',
        );
        const parsedData: WarehouseDashboardData[] = JSON.parse(
          modifiedData,
          (key, value) => {
            if (key === "warehouse_id") return String(value);
            return value;
          },
        );

        this.warehouseDashboardData = parsedData.map((item) => ({
          ...item,
          warehouse_id: String(item.warehouse_id),
        }));

        // Collect all unique warehouse names from parsedData
        const allWarehouseNames = parsedData
          .map((item) => item.warehouse_name)
          .filter((name) => name);
        // Filter valid data for temperature and humidity
        const validData = parsedData.filter(
          (item) =>
            item.warehouse_name &&
            (item.average_temperature !== undefined ||
              item.average_humidity !== undefined),
        );
        const warehouseNamesWithData = validData.map(
          (item) => item.warehouse_name,
        );

        // Ensure all warehouse names are included, padding with zeros where data is missing
        const completeWarehouseNames = Array.from(
          new Set([...allWarehouseNames]),
        );
        const averageTemperatures = completeWarehouseNames.map((name) => {
          const item = validData.find((d) => d.warehouse_name === name);
          return item ? item.average_temperature || 0 : 0;
        });
        const averageHumidity = completeWarehouseNames.map((name) => {
          const item = validData.find((d) => d.warehouse_name === name);
          return item ? item.average_humidity || 0 : 0;
        });

        // Optionally sort categories to match screenshot order
        const desiredOrder = [
          "Tabora Zone",
          "Dodoma Zone",
          "Dar es Salaam Zone",
          "Tanga Zone",
          "Mwanza Zone",
          "Dodoma HQ",
          "Mbeya Zone",
        ];
        const sortedWarehouseNames = completeWarehouseNames.sort((a, b) => {
          return desiredOrder.indexOf(a) - desiredOrder.indexOf(b);
        });
        const sortedTemperatures = sortedWarehouseNames.map(
          (name) =>
            averageTemperatures[completeWarehouseNames.indexOf(name)] || 0,
        );
        const sortedHumidity = sortedWarehouseNames.map(
          (name) => averageHumidity[completeWarehouseNames.indexOf(name)] || 0,
        );

        this.barChart = {
          ...this.barChart,
          xaxis: {
            ...this.barChart.xaxis,
            categories: sortedWarehouseNames,
          },
          series: [
            { name: "Temperature", data: sortedTemperatures },
            { name: "Humidity", data: sortedHumidity },
          ],
        };

        if (this.currentView === "warehouse") {
          this.originalWarehouseChart = { ...this.barChart };
        }
      } catch (error) {
        console.error("Error parsing dashboardData:", error);
      }
    }
  }

  async fetchZoneDetails(warehouseId: string): Promise<void> {
    this.currentView = "zone";
    this.selectedWarehouseId = warehouseId;
    this.loadingData = true;
    this.ngZone.run(() => {
      this.store.dispatch(
        StoreItemActions.getStoreItems({
          entity: StoreItemEntity.generalZoneReadingsDashboard,
          query: GET_ZONE_DASHBOARD_AVARAGE_READING_QUERY,
          filtering: { warehouse: warehouseId },
        }),
      );
    });

    this.store
      .select(selectStoreItems(StoreItemEntity.generalZoneReadingsDashboard))
      .subscribe((res: any) => {
        if (res && "dashboardData" in res) {
          this.processZoneDashboardData(res, warehouseId);
        }
        this.loadingData = false;
      });
  }

  processZoneDashboardData(
    data: ZoneDashboardStoreResponse,
    originalWarehouseId: string,
  ) {
    if (data && data.dashboardData) {
      try {
        const parsedData: ZoneDashboardData[] = JSON.parse(data.dashboardData);
        const validData = parsedData.filter(
          (item) =>
            item.zone_name &&
            (item.average_temperature !== undefined ||
              item.average_humidity !== undefined),
        );
        const zoneNames = validData.map((item) => item.zone_name);
        const averageTemperatures = validData.map(
          (item) => item.average_temperature || 0,
        );
        const averageHumidity = validData.map(
          (item) => item.average_humidity || 0,
        );

        this.barChart = {
          ...this.barChart,
          xaxis: { ...this.barChart.xaxis, categories: zoneNames },
          series: [
            { name: "Average Temperature", data: averageTemperatures },
            { name: "Average Humidity", data: averageHumidity },
          ],
        };
      } catch (error) {
        console.error("Error parsing zone dashboardData:", error);
      }
    }
  }

  goBackToWarehouses(): void {
    this.currentView = "warehouse";
    this.selectedWarehouseId = null;
    this.barChart = { ...this.originalWarehouseChart };
    this.fetchWarehouseDetails();
  }

  loadAlertData() {
    this.loadingData = true;
    this.alertService.getAlertData().subscribe((data) => {
      this.processAlertCounts(data);
      this.updateRadialChart();
      this.loadingData = false;
    });
    this.alertService.fetchAlertData();
  }

  processAlertCounts(alertData: Alert[]) {
    const countsMap = new Map<string, number>();
    alertData.forEach((alert) => {
      const warehouse = alert.warehouseName || "Unknown";
      countsMap.set(warehouse, (countsMap.get(warehouse) || 0) + 1);
    });

    this.alertCounts = Array.from(countsMap, ([warehouseName, count]) => ({
      warehouseName,
      count,
    })).sort((a, b) => b.count - a.count);
  }

  updateRadialChart() {
    const totalAlerts = this.warehouseAlertCount?.totalAlerts;
    this.radialChart.series = this.warehouseAlertCount?.alertsByWarehouse.map(
      (item) => Math.round((item.alertsCount / totalAlerts) * 100),
    );
    this.radialChart.labels = this.warehouseAlertCount?.alertsByWarehouse.map(
      (item) => item.warehouseName,
    );
    this.cdr.detectChanges();
  }

  toggleView(): void {
    if (this.currentView === "zone") {
      this.currentView = "warehouse";
      this.selectedWarehouseId = null;
      this.barChart = { ...this.originalWarehouseChart };
    }
  }

  protected readonly faTemperatureEmpty = faTemperatureEmpty;
  protected readonly faCircleExclamation = faCircleExclamation;
  protected readonly faDroplet = faDroplet;
  protected readonly faDotCircle = faDotCircle;
  protected readonly faCircle = faCircle;
  protected readonly faWarehouse = faWarehouse;
  protected readonly faBuilding = faBuilding;
  protected readonly faLocationCrosshairs = faLocationCrosshairs;
  protected readonly faThermometer = faThermometer;
  alertCounts: { warehouseName: string; count: number }[] = [];
}
